@if (!initializing) {
  <div class="dialog">
    <h1>Choose Location</h1>
    @if (hasSubGalleries) {
      <div class="galleries-warning-message">
        <app-svg src="/assets/icons/16/info.svg"></app-svg>
        <span>Galleries with Sub-Galleries can only be moved into folders.</span>
      </div>
    }
    <app-finder
      (onSelectFolder)="onSelectFolder($event)"
      (onSelectGallery)="onSelectGallery($event)"
      [blockGallerySelection]="!gallery || hasSubGalleries"
      [hideSubGalleries]="true"
      [allowFolderAndGalleryAsTarget]="!!gallery"
      [currentFolder]="selectedFolder"
      [currentGallery]="selectedGallery"
      [filterOut]="[gallery]"
      [reOpenFn]="reOpenFn()"
    >
    </app-finder>
    <br />
    @if (!('gallery:sub-gallery' | billingScope) && selectedGallery) {
      <div>
        <b>Sub galleries are not supported on {{ state.plan.price.product.name }}.</b>
        <a [routerLink]="['/a', 'pricing']" class="primary-link"> Upgrade </a>
      </div>
    } @else {
      <div class="bottom-row">
        <div class="fake-radio" [class.active]="mode === 'move'" (click)="changeMode('move')">Move Gallery</div>
        <div class="fake-radio" [class.active]="mode === 'copy'" (click)="changeMode('copy')">Copy Gallery</div>
        <div class="spacer"></div>
        <button
          appButton
          name="confirm"
          location="move-gallery-dialog"
          color="primary"
          (click)="submit()"
          weight="bold"
          shape="round"
          data-test-id="move-confirm"
        >
          @if (mode === 'move') {
            <span [class.hidden-text]="loading">Move Gallery</span>
          }
          @if (mode === 'copy') {
            <span [class.hidden-text]="loading">Copy Gallery</span>
          }
          @if (loading) {
            <app-loading-indicator color="white" size="small" class="button-loading-indicator"> </app-loading-indicator>
          }
        </button>
      </div>
    }
  </div>
}
@if (initializing) {
  <div class="dialog loading">
    <app-loading-indicator class="button-loading-indicator"> </app-loading-indicator>
  </div>
}
